namespace Solovis.Reports.Parameters {
    /**
     * ChoiceParameterControl presents a list of predetermined options to the user.
     * settings.options: array of {label, value}
     * settings.optionsAsync: function(callback(response, success)) that retrievs a list of options to use as response.result.
     */
    export class ChoiceParameterControl extends Solovis.UI.BaseControl {
        public static hasNewRender = true;
        public initialParameterValue;
        public settings;
        public _optionsToUse;
        public _select;
        public _currentValue;

        constructor(options) {
            super(options);

            this.initialParameterValue =
                typeof options.initialValue != "undefined"
                    ? options.initialValue
                    : null;

            this.settings = options.settings ? options.settings : {};

            this._optionsToUse = null;
            if (this.settings.options) {
                this._optionsToUse = this.settings.options;
            }
        }

        public doInitAsync() {
            var self = this;

            if (this._optionsToUse) {
                this.notifyInitComplete();
            } else {
                if (this.settings.optionsAsync) {
                    this.settings.optionsAsync(function (response, success) {
                        if (success) {
                            self._optionsToUse = response.result;
                        }

                        self.notifyInitComplete();
                    });
                } else {
                    this.notifyInitComplete();
                }
            }
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        private async doRenderNew() {

            const target = this.container[0];
            const self = this;

            await Solovis.UX.Utils.placeComponent("Select", target, {
                defaultValue: self._optionsToUse.find(item => item.value === self.initialParameterValue),
                isSearchable: !!self.settings.isSearchable,
                options: self._optionsToUse,
                getOptionLabel: (option) => option.label,
                getOptionValue: (option) => option.value,
                onChange: (item) => {
                    self.setParameterValue(item.value);
                    self.notifyParameterValueChanged();
                },
            });
        }

        public doRenderClassic() {
            var self = this;

            this.container.addClass("report-param-choice");

            this._select = $("<select>").appendTo(this.container);

            if (this._optionsToUse) {
                $(this._optionsToUse).each(function (i, choiceOption: any) {
                    $("<option>")
                        .attr("value", i)
                        .text(choiceOption.label)
                        .appendTo(self._select);
                });
            }

            var newIndex = this._findMatchingIndex(this.initialParameterValue);
            if (newIndex >= 0) {
                this._select.val(newIndex);
            } else {
                $("<option>").attr("value", -1).text("").appendTo(self._select);
                this._select.val(-1);
            }

            $(this._select).change(function () {
                var newIndex = parseInt(self._select.val());
                if (newIndex >= 0) {
                    var selectedOption = self._optionsToUse[newIndex];
                    self._currentValue = selectedOption.value;
                    self.notifyParameterValueChanged();
                } else {
                    self._currentValue = null;
                    self.notifyParameterValueChanged();
                }
            });

            this._currentValue = this.initialParameterValue;
        }

        public setParameterValue(newValue) {
            if (this._select) {
                this._currentValue = newValue;
                var newIndex = this._findMatchingIndex(newValue);
                if (newIndex >= 0) {
                    this._select.val(newIndex);
                }
            } else {
                this.initialParameterValue = newValue;
            }
        }

        public getParameterValue() {
            if (this._select) {
                return Solovis.deepCopy(this._currentValue);
            } else {
                return Solovis.deepCopy(this.initialParameterValue);
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }

        public _findMatchingIndex(value) {
            if (this._optionsToUse) {
                for (var i = 0; i < this._optionsToUse.length; i++) {
                    var option = this._optionsToUse[i];
                    if (this._compareValues(value, option.value)) {
                        return i;
                    }
                }
            }

            return -1;
        }

        public _compareValues(a, b) {
            if (Solovis.isNotNull(a) && Solovis.isNotNull(b)) {
                var typeOfA = typeof a;
                var typeOfB = typeof b;

                if (typeOfA != typeOfB) {
                    return false;
                } else if (typeOfA == "object") {
                    if (a.entityId && a.entityId == b.entityId) {
                        return true;
                    } else if (a.investmentId && a.investmentId == b.investmentId) {
                        return true;
                    } else if (a.id && a.id == b.id) {
                        return true;
                    }
                    // TODO: Support other major parameter types.
                } else {
                    return a == b;
                }
            } else if (Solovis.isNull(a) && Solovis.isNull(b)) {
                return true;
            } else {
                return false;
            }
        }
    }
}
